'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _PropTypes = require('../utils/PropTypes');

var _PropTypes2 = _interopRequireDefault(_PropTypes);

var _ = require('.');

var _2 = _interopRequireDefault(_);

var _jssThemeReactor = require('jss-theme-reactor');

var _InfiniteScroll = require('./InfiniteScroll');

var _InfiniteScroll2 = _interopRequireDefault(_InfiniteScroll);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _orderBy2 = require('lodash/orderBy');

var _orderBy3 = _interopRequireDefault(_orderBy2);

var _groupBy2 = require('lodash/groupBy');

var _groupBy3 = _interopRequireDefault(_groupBy2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var passthrough = function passthrough(v) {
  return v;
};

var styleSheet = (0, _jssThemeReactor.createStyleSheet)('ListGroup', function (theme) {
  var _ref;

  return _ref = {
    root: {
      backgroundColor: theme.palette.background.paper
    },
    expandItemHeight: {
      marginTop: theme.typography.rhythmByUnit(2),
      marginBottom: theme.typography.rhythmByUnit(2)
    },
    firstExpandItemHeight: {
      marginTop: 0
    },
    lastExpandItemHeight: {
      marginBottom: 0
    }
  }, _defineProperty(_ref, theme.breakpoints.up('sm'), {
    expandableList: {
      paddingLeft: theme.typography.rhythmByUnit(2),
      paddingRight: theme.typography.rhythmByUnit(2)
    },
    expandItemWidth: {
      marginRight: theme.typography.rhythmByUnit(-2),
      marginLeft: theme.typography.rhythmByUnit(-2)
    }
  }), _defineProperty(_ref, 'progress', {
    paddingTop: theme.typography.rhythmByUnit(2),
    paddingBottom: theme.typography.rhythmByUnit(2)
  }), _ref;
});

var ListGroup = (_temp2 = _class = function (_PureComponent) {
  _inherits(ListGroup, _PureComponent);

  function ListGroup() {
    var _ref2;

    var _temp, _this, _ret;

    _classCallCheck(this, ListGroup);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = ListGroup.__proto__ || Object.getPrototypeOf(ListGroup)).call.apply(_ref2, [this].concat(args))), _this), _this.renderListItemText = function (value) {
      return typeof value === 'string' ? _react2['default'].createElement(_.ListItemText, { primary: value }) : _react2['default'].createElement(_.ListItemText, value);
    }, _this.renderListItem = function (value, className, key, index, length) {
      var expandable = _this.props.expandable;


      if ((0, _react.isValidElement)(value)) {
        var expand = value.props.expand;


        return _react2['default'].createElement(
          'div',
          { key: key + '.' + index },
          _react2['default'].cloneElement(value, expandable ? { className: className, divider: index !== length } : // Don't pass an expand prop through to the
          // item if it was provided and the ListGroup is
          // not expandable
          Object.assign({
            divider: index !== length
          }, expand !== undefined && { expand: false }))
        );
      }

      var props = typeof value === 'string' ? { primary: value } : value;

      var _props = Object.assign({}, props.onClick || props.href ? { button: true, ripple: false } : {}, props),
          onClick = _props.onClick,
          href = _props.href,
          button = _props.button,
          ripple = _props.ripple,
          _props$divider = _props.divider,
          divider = _props$divider === undefined ? true : _props$divider,
          _props$dense = _props.dense,
          dense = _props$dense === undefined ? true : _props$dense,
          others = _objectWithoutProperties(_props, ['onClick', 'href', 'button', 'ripple', 'divider', 'dense']);

      return _react2['default'].createElement(
        'div',
        { key: key + '.' + index, className: className },
        _react2['default'].createElement(
          _.ListItem,
          {
            onClick: onClick,
            href: href,
            button: button,
            ripple: ripple,
            dense: dense,
            divider: index !== length
          },
          _this.renderListItemText(others)
        )
      );
    }, _this.renderList = function (values, key) {
      var _classNames2;

      var _this$props = _this.props,
          mapListItem = _this$props.mapListItem,
          maxLength = _this$props.maxLength,
          elevation = _this$props.elevation,
          collapseBy = _this$props.collapseBy,
          expandable = _this$props.expandable,
          loadMore = _this$props.loadMore,
          hasMore = _this$props.hasMore,
          threshold = _this$props.threshold,
          scrollEl = _this$props.scrollEl,
          waitingForLoad = _this$props.waitingForLoad,
          children = _this$props.children;


      var valuesLength = values.length - 1;
      var classes = _this.context.styleManager.render(styleSheet);
      var listClassName = (0, _classnames2['default'])(_defineProperty({}, classes.expandableList, expandable));
      var listItemClassName = (0, _classnames2['default'])((_classNames2 = {}, _defineProperty(_classNames2, classes.expandItemHeight, expandable), _defineProperty(_classNames2, classes.expandItemWidth, expandable), _classNames2));

      var items = values;
      if (maxLength != null) {
        items = items.slice(0, maxLength);
      }
      items = items.map(function (v, i) {
        var _classNames3;

        var itemClasses = (0, _classnames2['default'])(listItemClassName, (_classNames3 = {}, _defineProperty(_classNames3, classes.firstExpandItemHeight, expandable && i === 0), _defineProperty(_classNames3, classes.lastExpandItemHeight, expandable && i === valuesLength), _classNames3));
        return _this.renderListItem(mapListItem(v), itemClasses, key, i, valuesLength);
      });

      var Content = function () {
        function Content() {
          return _react2['default'].createElement(
            _2['default'],
            { collapse: collapseBy, padding: false, className: listClassName },
            items,
            children
          );
        }

        return Content;
      }();

      // disable infinite scroll on this element when in grouped mode since we have it on our parent
      var infiniteSort = key === 'list' && loadMore;
      if (infiniteSort) {
        return _react2['default'].createElement(
          _InfiniteScroll2['default'],
          {
            waitingForLoad: waitingForLoad,
            threshold: threshold,
            scrollEl: scrollEl,
            loadMore: loadMore,
            hasMore: hasMore
          },
          _react2['default'].createElement(Content, null)
        );
      }

      return _react2['default'].createElement(Content, null);
    }, _this.renderListGroup = function (value) {
      var _this$props2 = _this.props,
          groupOrder = _this$props2.groupOrder,
          containerHeight = _this$props2.containerHeight,
          className = _this$props2.className,
          scrollEl = _this$props2.scrollEl,
          loadMore = _this$props2.loadMore,
          threshold = _this$props2.threshold,
          waitingForLoad = _this$props2.waitingForLoad,
          hasMore = _this$props2.hasMore;


      var keys = groupOrder || Object.keys(value).sort();

      var items = keys.filter(function (k) {
        return value[k];
      }).map(function (k) {
        return _react2['default'].createElement(
          'div',
          { key: k },
          _this.renderHeading(_this.props.mapHeading(k)),
          _this.renderList(value[k], k + '.list')
        );
      });

      return _react2['default'].createElement(
        'div',
        { className: className },
        loadMore ? _react2['default'].createElement(
          _InfiniteScroll2['default'],
          {
            waitingForLoad: waitingForLoad,
            threshold: threshold,
            scrollEl: scrollEl,
            loadMore: loadMore,
            hasMore: hasMore
          },
          items
        ) : items
      );
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ListGroup, [{
    key: 'renderHeading',
    value: function () {
      function renderHeading(value) {
        return typeof value === 'string' ? _react2['default'].createElement(
          _.ListSubheader,
          null,
          value
        ) : _react2['default'].createElement(_.ListSubheader, value);
      }

      return renderHeading;
    }()
  }, {
    key: 'groupBy',
    value: function () {
      function groupBy(data, key) {
        return (0, _groupBy3['default'])(data, key);
      }

      return groupBy;
    }()
  }, {
    key: 'orderBy',
    value: function () {
      function orderBy(data, keys, orders) {
        return (0, _orderBy3['default'])(data, keys, orders);
      }

      return orderBy;
    }()
  }, {
    key: 'render',
    value: function () {
      function render() {
        var _props2 = this.props,
            value = _props2.value,
            classNameProp = _props2.classNameProp,
            groupBy = _props2.groupBy,
            sortByProp = _props2.sortBy,
            orderByProp = _props2.orderBy;

        var sortBy = sortByProp === undefined || sortByProp instanceof Array ? sortByProp : [sortByProp];
        var orderBy = orderByProp === undefined ? [] : orderByProp instanceof Array ? orderByProp : [orderByProp];
        var data = (value || []).slice();
        var classes = this.context.styleManager.render(styleSheet);
        var className = (0, _classnames2['default'])(classes.root, classNameProp);

        if (sortBy) {
          data = this.orderBy(data, sortBy, orderBy);
        }
        if (groupBy) {
          data = this.groupBy(data, groupBy);
        }

        return _react2['default'].createElement(
          'div',
          { className: className },
          data instanceof Array ? this.renderList(data, 'list') : this.renderListGroup(data)
        );
      }

      return render;
    }()
  }]);

  return ListGroup;
}(_react.PureComponent), _class.propTypes = {
  /**
   * List elements to be displayed
   */
  value: _PropTypes2['default'].array,
  /**
   * The CSS class name of the root element.
   */
  className: _PropTypes2['default'].string,
  classNameProp: _PropTypes2['default'].oneOfType([_PropTypes2['default'].string, _PropTypes2['default'].array]),
  containerHeight: _PropTypes2['default'].number,
  /**
   * Function that takes a list item's props as argument and collapses item if it returns true.
   */
  collapseBy: _PropTypes2['default'].func,
  /**
   * If true, expansion styling applied to list and items
   */
  expandable: _PropTypes2['default'].bool,
  /**
   * Key or function to sort items by
   */
  sortBy: _PropTypes2['default'].oneOfType([_PropTypes2['default'].string, _PropTypes2['default'].func, _PropTypes2['default'].arrayOf(_PropTypes2['default'].oneOfType([_PropTypes2['default'].string, _PropTypes2['default'].func]))]),
  /**
   * Key or function to order items by
   */
  orderBy: _PropTypes2['default'].oneOfType([_PropTypes2['default'].string, _PropTypes2['default'].func, _PropTypes2['default'].arrayOf(_PropTypes2['default'].oneOfType([_PropTypes2['default'].string, _PropTypes2['default'].func]))]),
  /**
   * Key or function to group items by
   */
  groupBy: _PropTypes2['default'].oneOfType([_PropTypes2['default'].string, _PropTypes2['default'].func]),
  /**
   * Ordered list of group headers
   */
  groupOrder: _PropTypes2['default'].arrayOf(_PropTypes2['default'].string),
  /**
   * Map the group heading value
   */
  mapHeading: _PropTypes2['default'].func,
  /**
   * Formats the value item to ListItem properties
   */
  mapListItem: _PropTypes2['default'].func,
  /**
   * Length of elements to be displayed
   */
  maxLength: _PropTypes2['default'].number,
  /**
   * Shadow depth, corresponds to `dp` in the spec.
   */
  elevation: _PropTypes2['default'].number,

  /**
   * A callback when more items are requested by react-infinite-scroller.
   */
  loadMore: _PropTypes2['default'].func,

  /**
   * the distance from the bottom of the container (in px) at which to call `loadMore`
   */
  threshold: _PropTypes2['default'].number,

  /**
   * Whether there are more items to be loaded by react-infinite-scroller.
   */
  hasMore: _PropTypes2['default'].bool,

  /**
   * The element to be used for infinite scrolling calculations.
   */
  scrollEl: _PropTypes2['default'].object,

  /**
   * Element to render while loading more data. Defaults to a CircularProgress indicator,
   * which is recommended by Material UI.
   */
  loader: _PropTypes2['default'].element,

  /**
   * boolean indicating whether or not `loadMore` should be called
   */
  waitingForLoad: _PropTypes2['default'].bool,

  /**
   * Can be any node or number of nodes.
   */
  children: _PropTypes2['default'].node
}, _class.defaultProps = {
  mapHeading: passthrough,
  mapListItem: passthrough,
  expandable: false,
  elevation: 2
}, _class.contextTypes = {
  styleManager: _PropTypes2['default'].styleManager.isRequired
}, _temp2);
exports['default'] = ListGroup;


ListGroup.displayName = 'ListGroup';


//////////////////
// WEBPACK FOOTER
// ../node_modules/@catalytic/pushbot-ui/List/ListGroup.js
// module id = 1824
// module chunks = 32